const uiConstants = {
  DISPLAY_PANEL_HEIGHT: 90,
  PHONE_VERTICAL_BREAKPOINT: 480,
  PHONE_VERTICAL_MARGIN: 100,
};

export default uiConstants;


// WEBPACK FOOTER //
// ./src/consts/uiConstants.js